<template>
  <div class="component-body">
    <div role="tooltip" x-placement="top" class="el-tooltip__popper is-dark"
         style="position: relative; width: 40px; text-align: center;">Dark
      <div x-arrow="" class="popper__arrow"></div>
    </div>
    <div role="tooltip" x-placement="top" class="el-tooltip__popper is-light"
         style="margin-top: 10px; position: relative; width: 40px; text-align: center;">Light
      <div x-arrow="" class="popper__arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/29/Tooltip/index.vue